import { render, staticRenderFns } from "./EarnLimitedCoins.vue?vue&type=template&id=c9a9f3e6&"
import script from "./EarnLimitedCoins.vue?vue&type=script&lang=ts&"
export * from "./EarnLimitedCoins.vue?vue&type=script&lang=ts&"
import style0 from "./EarnLimitedCoins.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports